<template>

</template>

<script>
    export default {
        name: "ChangeTheme"
    }
</script>

<style >
  @font-face {
    font-family: "IRANSans";
    font-style: normal;
    font-weight: normal;
    src: url("../assets/fonts/iranSans/eot/IRANSansWeb.eot");
    src: url("../assets/fonts/iranSans/eot/IRANSansWeb.eot?#iefix") format('embedded-opentype'),
    url('../assets/fonts/iranSans/woff2/IRANSansWeb.woff2') format('woff2'),
    url('../assets/fonts/iranSans/woff/IRANSansWeb.woff') format('woff'),
    url('../assets/fonts/iranSans/ttf/IRANSansWeb.ttf') format('truetype');
  }

  * {
    font-family: "Arial";
  }
</style>
